import { Box, Button, Stack, styled } from "@mui/material";
import { DoorClosed } from "lucide-react";
import { useTranslation } from "next-i18next";
import CustomButton from "../_shared/CustomButton";

// SOLS Group's careers page lists open roles at every SOLS company, so a
// closed job here sends people there, in a new tab since it is another site.
const GROUP_CAREERS_URL = "https://www.sols247.com/careers";

// The two actions share a width so they read as a pair.
const ACTION = { width: "100%", maxWidth: 300 };

// The secondary action, dark where the primary is yellow, as on the other
// careers sites. CustomButton is primary-only, and the theme forces dark text
// on every contained button, so this is a text-variant button given the
// contained buttons' type, shape and padding with its own colours.
const SecondaryButton = styled(Button)(({ theme }) => ({
  width: "100%",
  fontWeight: 700,
  borderRadius: "5px",
  boxShadow: "1px 1px 5px 0 rgba(0,0,0,.1)",
  fontFamily: '"Open Sans", Helvetica, Arial, Verdana, sans-serif',
  fontSize: "1rem",
  padding: "0.6rem",
  backgroundColor: theme.palette.primary.dark,
  color: "#fff",
  "&:hover": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.dark,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.8rem",
  },
}));

// Shown in place of every apply control on a closed job's page.
const ClosedJobPanel = ({ departmentId }: { departmentId?: string }) => {
  const { t } = useTranslation("careers");

  return (
    <div>
      <h2>{t("closed-h2")}</h2>
      <Box
        sx={{
          bgcolor: "background.default",
          borderRadius: 2,
          px: 3,
          py: 5,
          textAlign: "center",
        }}
      >
        <Stack spacing={2} alignItems="center">
          <DoorClosed size={32} color="#6b7280" aria-hidden="true" />
          <h3>{t("closed-h3")}</h3>
          <p>{t("closed-p")}</p>
          <Stack spacing={1.5} alignItems="center" sx={{ width: "100%" }}>
            <Box component="a" href={GROUP_CAREERS_URL} target="_blank" rel="noopener" sx={ACTION}>
              <CustomButton sx={{ width: "100%" }}>{t("closed-view-positions")}</CustomButton>
            </Box>
            {departmentId && (
              <Box
                component="a"
                href={`${GROUP_CAREERS_URL}/apply?hs_role=${encodeURIComponent(departmentId)}`}
                target="_blank"
                rel="noopener"
                sx={ACTION}
              >
                <SecondaryButton variant="text" color="inherit">
                  {t("closed-open-application")}
                </SecondaryButton>
              </Box>
            )}
          </Stack>
        </Stack>
      </Box>
    </div>
  );
};

export default ClosedJobPanel;
